import {
  LoginForm,
} from '@/components';

export default {
  name: 'Login',
  components: {
    LoginForm,
  },
};
